/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {AdnApiClientService} from '../../common/controller/adn-api-client.service';
import {AdminObjectState, SignalAdminResourceApiBase} from '../../common/controller/signal-admin-resource-api';

export interface ApiKeyModel {
  id: string;
  name?: string;
  description?: string;
  scopes?: string[];
  fullAccess?: boolean;
  expiry?: Date | string | null;
  modExpiry?: Date | string | null;
  accessExpiry?: Date | string | null;
  lastUsed?: Date | string | null;
  expired?: boolean;
  revocable?: boolean;
  agentLease?: boolean;
  apiKey?: string;
  objectState?: AdminObjectState;
  validationWarnings?: any[];
}

@Injectable({providedIn: 'root'})
export class ApiKeyApiService extends SignalAdminResourceApiBase<ApiKeyModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'apikeys');
  }

  revoke(id: string): Observable<Partial<ApiKeyModel>> {
    return this.client.request({
      method: 'POST',
      url: this.resourceUri(`apikeys/${id}/revoke`),
      body: {}
    });
  }
}
